export default {
  aboutIranPhoenix: "درباره ایران فونیکس",

  aboutDescription: `تیم زبان‌کید، مجموعه‌ای از متخصصین در حوزه زبان انگلیسی است که سال‌ها به‌صورت تخصصی در رده‌های سنی کودک و نوجوان فعالیت داشته‌اند. این تیم با سابقه‌ای نزدیک به ۲۰ سال آموزش، علاوه بر تألیف و ترجمه حدود ۳۰ کتاب در حوزه آموزش زبان، در حوزه بین‌الملل نیز عناوین ارزشمندی به دست آورده است. این تیم تحت نظر آقای محمد خالد فیضی موفق شده است در جشنواره‌های جهانی کانادا، رومانی، لهستان، مالزی، لبنان و ژاپن، در حوزه ابداع شیوه‌های نوین آموزش زبان به کودکان، مدال طلا و تقدیرنامه کسب کند و اکنون با کوله‌باری از تجربه و افتخارات در خدمت کودکان عزیز سرزمین ایران باشد.`,

  variousGames: "بازی متنوع",
  learningPracticeEntertainment: "یادگیری، تمرین و سرگرمی در یک تجربه متفاوت",

  educationalVideos: "ویدیو آموزشی",
  learningWithVideos: "یادگیری زبان با ویدیوهای جذاب و کاربردی",

  audioFiles: "فایل صوتی",
  listeningSkills: "تقویت مهارت شنیداری با صداهای جذاب و کاربردی",

};
